import type { ReactNode } from "react";

type ServiceDetailsBlockCardProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  renderLabels?: () => ReactNode;
} & (
  | {
      backgroundImage: string;
      thumbnailImage: string | undefined;
    }
  | {
      backgroundImage?: never;
      thumbnailImage?: never;
    }
);

export function ServiceDetailsBlockCard({
  title,
  subtitle,
  backgroundImage,
  thumbnailImage,
  children,
  renderLabels,
}: ServiceDetailsBlockCardProps): ReactNode {
  return (
    <div className="flex w-full flex-col gap-4 rounded-lg bg-white">
      {backgroundImage && (
        <div className="relative w-full">
          {backgroundImage && (
            <div
              className="h-64 w-full rounded-t-lg bg-grey-400 bg-cover bg-center p-2"
              style={{
                backgroundImage: `url(${backgroundImage})`,
              }}
            >
              {renderLabels && <div className="absolute left-3 top-3 flex gap-2">{renderLabels()}</div>}
            </div>
          )}
          {thumbnailImage && (
            <img
              className="absolute right-8 size-24 -translate-y-1/2 rounded-full border-4 border-white bg-white object-cover"
              src={thumbnailImage}
              alt={title}
            />
          )}
        </div>
      )}
      <div className="flex flex-col gap-2 p-4">
        {title && <span className="mb-2 break-words text-headline3 leading-old-headline4">{title}</span>}
        {subtitle && <span className="break-words text-body-bold">{subtitle}</span>}
        {children}
      </div>
    </div>
  );
}
